import './stylesheets/Top.css';
import top_image from './images/top-image.png';

function Top() {
    return (
      <div id="Top">
        <div>
            <div id="Title">
                VIDEO EXPRESS
            </div>
            <img src={top_image} id='Banner-top-image'/>
        </div>
      </div>
    );
  }
  
  export default Top;